import { translationReactComponentsEn, translationReactComponentsEs } from '@pba/react-components';
import { translationReactUtilitiesEn, translationReactUtilitiesEs } from '@pba/react-utils';
import { getTranslationCountries } from 'common/utils/countries';
import { getTranslationLanguages } from 'common/utils/languages';
import { getTranslationStates } from 'common/utils/states';
import translationEN from './en/resource.json';
import translationES from './es/resource.json';
import { type AppLanguage, appLanguages } from './supported-app-languages-names';

export const supportedAppLanguageCodes: AppLanguage[] = Object.values(appLanguages);

export type AppLanguageEntry = {
  code: AppLanguage;
  label: string;
};

const supportedAppLanguages: AppLanguageEntry[] = Object.entries(appLanguages).map(([name, code]) => ({
  code,
  label: name,
}));

export type LocaleConfig<T> = {
  locale: T;
  name: string;
};

export const resources = {
  [appLanguages.english]: {
    translationCountries: getTranslationCountries(appLanguages.english),
    translationLanguages: getTranslationLanguages(appLanguages.english),
    translationReactComponents: translationReactComponentsEn,
    translationReactUtilities: translationReactUtilitiesEn,
    translations: translationEN,
    translationStates: getTranslationStates(appLanguages.english),
  },
  [appLanguages.spanish]: {
    translationCountries: getTranslationCountries(appLanguages.spanish),
    translationLanguages: getTranslationLanguages(appLanguages.spanish),
    translationReactComponents: translationReactComponentsEs,
    translationReactUtilities: translationReactUtilitiesEs,
    translations: translationES,
    translationStates: getTranslationStates(appLanguages.spanish),
  },
};

export const getSupportedAppLanguages = () => supportedAppLanguages;
